<template>
    <w-dialog
      @close="verifyClose"
      :show.sync="computedVisable"
      title="身份验证"
      :wallStyle="{ zIndex: 2001 }"
      :box-style="{ width: '428px', zIndex: 2001 }"
      :bodyStyle="{ padding: '24px 24px 0 24px' }"
      :footerStyle="{
        padding: '2px 24px 24px 24px',
        borderTop: 'none'
      }"
    >
      <p v-if="!isSendCode">为保证企业的数据安全，请进行身份验证</p>
      <p v-else>验证码已发送至尾号 {{phone.slice(7)}} 的密保手机</p>
      <div key="4" class="phone-number-wrapper">
          <input :style="[{borderColor:(loginVerifyError?'#E02020':'')},{zIndex:(loginVerifyError?1:'')}]" placeholder="6位短信验证码" v-model.trim="verifyForm.verification" class="input-mobile-member verification-input">
          </input>
          <button type="button" class="verification-button" :class="!isDisabled&&verifyForm.timer==0?'':'disabled'">
              <Countdown :autoStart="isDisabled" :time="verifyForm.timer" @click="getDoubleVerification(phone)"  @finish="countFinis" />
            </button>
        </div>
        <p key="5" class="error-tips">
          <!-- <i v-show="loginVerifyError" class="r2-icon-alert_error" style="position: relative;"></i> -->
          {{loginVerifyError}}
        </p>
      </div>
      <!-- <p v-else>验证码已发送至尾号  {{phone.slice(7)}}  的密保手机</p> -->
      <div slot="footer" style="margin-top:70px">
          <w-button
            type="primary"
            size="small"
            @click="verifyCode"
            >确定</w-button
          >
          <w-button type="minor" @click="verifyClose">取消</w-button>
      </div>
    </w-dialog>
</template>
<style lang="less" scoped>
    .phone-number-wrapper{
          display: flex;

        }
        .error-tips{
              margin-top: 12px;
              color: red;
          }
        .input-mobile-member{
          flex: 1;
          width: 100%;
          font-size: 16px;
          box-sizing: border-box;
          padding-left: 12px;
          height:48px;
          border-radius:4px;
          border:1px solid rgba(33,37,48,0.15);
          background-color: #fff;
          box-shadow: 0 0 0 2px rgba(255, 255, 255);
          border-radius: 0 4px 4px 0;
          &:hover{
            border:1px solid rgba(32,121,250,1);
            z-index: 1;
          }
          &:focus {
            outline: none;
            border-color: #2079fa;
            box-shadow: 0 0 0 2px rgba(24,144,255,.2);
            z-index: 1;
          }
        }
        .input-area-member{
          width: 80px;
          height:48px;
        }
        .verification-input{
          margin-top: 24px;
          box-shadow: 0;
          border-radius: 4px 0 0 4px;
          box-shadow: none;
        }
        .verification-button{
        cursor: pointer;
          position: relative;
          left: -1px;
          color:rgba(33,37,48,0.8);
          font-size:16px;
          font-weight:400;
          height: 46px;
          box-shadow: none;
          width: 100px;
          margin-top: 24px;
          border-radius: 0 4px 4px 0;
          background: #fff;
          border:1px solid rgba(222,223,224,1);
          &.disabled{
            cursor: not-allowed ;
            background: rgba(33,37,48,0.06);
          }
        }
</style>
<script>
import { getCookie, aes, appId, captchaId } from '@/assets/utils/CommonUtil'
import Countdown from '_c/common/countDown'
import LoginService from '@/assets/service/login'
export default {
  props: {
    showVerify: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Countdown
  },
  computed: {
    computedVisable: {
      get (){
        return this.showVerify
      },
      set (val){
        // this.showVerify = val
      }
    }
  },
  data (){
    return {
      isSendCode: false,
      verifyForm: {
        verification: null,
        timer: 0
      },
      loginVerifyError: '',
      isDisabled: false,
      phone: null
    }
  },
  mounted (){
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo) {
      userinfo = JSON.parse(userinfo)
      this.phone = userinfo.passwordMobile
    }
  },
  methods: {
    // 二次验证---关闭
    verifyClose (){
    //   this.computedVisable = false
      this.loginVerifyError = ''
      this.isSendCode = false
      this.verifyForm.timer = 0
      this.isDisabled = false
      this.verifyForm.verification = null
      // this.phone = null
      this.$emit('dialogVisibleEvent', false)
    },
    // 双因素验证---获取手机验证码验证
    getDoubleVerification (mobile){
      if (this.isDisabled){
        return false
      }
      this.isSendCode = true
      this.loginVerifyError = ''
      let time = new Date().getTime()
      let query = {
        mobile,
        appId,
        sign: aes(time, mobile),
        t: time
      }
      LoginService.fetchVerifyCode(query).then(res => {
        console.log(res)
        if (res.code === 200){
          this.isDisabled = true
          this.verifyForm.timer = 60
        } else {
          this.loginVerifyError = res.message
        }

      })
    },
    // 双因素验证---手机验证码验证
    verifyCode (){
      if (this.verifyForm.verification !== '' || this.verifyForm.verification !== null){
        LoginService.verifyCode(this.phone, this.verifyForm.verification).then(res => {
          if (res.code === 200){
            this.$emit('verifyConfirm')
            this.$emit('dialogVisibleEvent', false)
            this.$message.success('验证通过！')
          } else {
            this.loginVerifyError = res.message
          }
        })
      } else {
        this.loginVerifyError = '请输入验证码！'
      }
    },
    // 双因素验证---倒计时结束
    countFinis (){
      this.verifyForm.timer = 0
      this.isDisabled = false
    }
  }
}
</script>
